module.exports = __webpack_public_path__ + "static/media/math.dd263e3e.png";